import palette from '../theme/palette';

const variants = [
  {
    props: { color: 'internal' },
    style: {
      backgroundColor: palette.background.internal,
    },
  },
];

export default variants;
